import React from 'react';
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel3';
import partnerOne from '../../assets/images/1.svg';
import partnerTwo from '../../assets/images/20.svg';
import partnerThree from '../../assets/images/3.svg';
import partnerFour from '../../assets/images/4.svg';
import partnerFive from '../../assets/images/5.svg';
import partnerSix from '../../assets/images/19.svg';
import partner7 from '../../assets/images/7.svg';
import partner8 from '../../assets/images/8.svg';
import partner9 from '../../assets/images/9.svg';
import partner10 from '../../assets/images/10.svg';
import partner11 from '../../assets/images/11.svg';
import partner12 from '../../assets/images/12.svg';
import partner13 from '../../assets/images/13.svg';
import partner14 from '../../assets/images/14.svg';
import partner15 from '../../assets/images/15.svg';
import partner16 from '../../assets/images/16.svg';
import partner17 from '../../assets/images/17.svg';
import partner18 from '../../assets/images/18.svg';
import partner19 from '../../assets/images/19.svg';
import partner20 from '../../assets/images/20.svg';
import partner21 from '../../assets/images/21.svg';
import partner22 from '../../assets/images/22.svg';
import partner23 from '../../assets/images/23.svg';
import partner24 from '../../assets/images/24.svg';

const options = {
    loop: true,
    nav: false,
    dots: false,
    smartSpeed: 2000,
    margin: 30,
    autoplayHoverPause: true,
    autoplay: true,
    navText: [
        "<i class='flaticon-back'></i>",
        "<i class='flaticon-right'></i>"
    ],
    responsive: {
        0: {
            items: 2
        },
        576: {
            items: 3
        },
        768: {
            items: 4
        },
        1200: {
            items: 6
        }
    }
}
 
class PartnerLogo extends React.Component {
    render(){
        return (
            <div className="partner-area uk-section uk-padding-remove-top">
                <div className="uk-container">
                    {/* <div className="partner-slides owl-carousel owl-theme"> */}
                    <OwlCarousel 
                        className="partner-slides owl-carousel owl-theme"
                        {...options}
                    >
                        <div className="item">
                            <Link to="#">
                                <img src={partnerOne} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partnerTwo} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partnerThree} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partnerFour} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partnerFive} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partnerSix} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partner7} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partner8} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partner9} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partner10} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partner11} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partner12} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partner13} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partner14} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partner15} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partner16} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partner17} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partner18} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partner19} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partner20} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partner21} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partner22} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partner23} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partner24} alt="Partner" />
                            </Link>
                        </div>
                        </OwlCarousel>
                    {/* </div> */}
                </div>
            </div>
        );
    }
}
 
export default PartnerLogo;